import React from 'react';
import { Container } from 'semantic-ui-react';
import { BodyClass, Helmet } from '@plone/volto/helpers';

export const AVISO_LOGIN_DESLIGADO = {
  titulo: 'Entrada não disponível por este endereço',
  texto:
    'A edição do portal não é feita por este endereço. Editores devem usar o endereço interno do MPF.',
};

/**
 * Página mostrada no lugar do formulário de login quando o frontend público
 * roda com o login desligado (AB#12105). Sem link para o formulário: a
 * chamada de login da API responde 403 neste endereço, e um formulário aqui
 * só produziria "falha na autenticação" para quem tem a senha certa.
 */
const AvisoLoginDesligado: React.FC = () => (
  <Container className="view-wrapper">
    <Helmet title={AVISO_LOGIN_DESLIGADO.titulo} />
    <BodyClass className="view-login-desligado" />
    <section className="mpf-login-desligado py-12">
      <h1 className="mb-4 text-h2 font-semibold text-primary dark:text-night-100 sm:text-h1 sm:font-bold">
        {AVISO_LOGIN_DESLIGADO.titulo}
      </h1>
      <p className="mb-0 text-lg text-on-surface sm:text-reading">
        {AVISO_LOGIN_DESLIGADO.texto}
      </p>
    </section>
  </Container>
);

export default AvisoLoginDesligado;
